import { styled, Tab, Tabs } from '@mui/material';

interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

export const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    width: '100%',
    backgroundColor: '#FFC800',
  },
});

interface StyledTabProps {
  label: string;
}

export const StyledTab = styled((props: StyledTabProps) => <Tab {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    fontWeight: '700',
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: '#1E242F',
    '&.Mui-selected': {
      color: '#1E242F',
    },
    '&.Mui-focusVisible': {
      backgroundColor: '#FFC800',
    },
  })
);

export default { StyledTabs, StyledTab };
